import { Component, AfterViewInit, ElementRef, Input, OnInit } from '@angular/core';
import { SessionService } from '../../shared/services/session.service';
import { element } from 'protractor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, Response, RequestOptions, Headers } from '@angular/http';

declare var jquery: any;
declare var $: any;


@Component({
  selector: 'app-storyassigningpage',
  templateUrl: './storyassigningpage.component.html',
  styleUrls: ['./storyassigningpage.component.css']
})
export class StoryassigningpageComponent implements OnInit, AfterViewInit {
  public echapter1: string;
  public echapter2: string;
  public bloburl: string;
  public button1;
  public button2;
  public button3;
  public button4;
  public button5;
  public button6;
  public button7;
  public button8;
  public button9;
  public button10;
  public button11;
  public button12;
  public button13;
  public button14;
  public button15;
  
  constructor(

    private sessionService: SessionService,

    private elementRef: ElementRef) {

    let native = this.elementRef.nativeElement;

    this.bloburl = this.sessionService.bloburl;
    this.button1 = 0;
    this.button2 = 0;
    this.button3 = 0;
    this.button4 = 0;
    this.button5 = 0;

    this.button6 = 0;
    this.button7 = 0;
    this.button8 = 0;
    this.button9 = 0;
    this.button10 = 0;

    this.button11 = 0;
    this.button12 = 0;
    this.button13 = 0;

    this.button14 = 0;
    this.button15 = 0;

  }


  async ngAfterViewInit() {

    await this.loadScript('/src/assets/Scripts/jquery-1.12.3.min.js');
    await this.loadScript('https://ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min.js');
    await this.loadScript('https://ajax.googleapis.com/ajax/libs/jqueryui/1.11.3/jquery-ui.min.js');
  
  }


  private loadScript(scriptUrl: string) {
    return new Promise((resolve, reject) => {
      const scriptElement = document.createElement('script');
      scriptElement.src = scriptUrl;
      scriptElement.onload = resolve;
      document.body.appendChild(scriptElement);
    })
  }



  public ngOnInit() {
    
  }


  private f3() {

    
        let stringToSplit = this.echapter2;
    let x = stringToSplit.split(",");

    for (let i = 0; i <= x.length; i++) {
      let cname = "button" + x[i];


      if (x[i] == "1") {
        var element = <HTMLInputElement>document.getElementById("button1");
        element.removeAttribute("class");
        element.setAttribute("class", "enabled");
        this.button1 = 1;
      }


      if (x[i] == "2") {
        var element = <HTMLInputElement>document.getElementById("button2");
        element.removeAttribute("class");
        element.setAttribute("class", "enabled");
        this.button2 = 1;
      }
      if (x[i] == "3") {
        var element = <HTMLInputElement>document.getElementById("button3");
        element.removeAttribute("class");
        element.setAttribute("class", "enabled");
        this.button3 = 1;
      }
      if (x[i] == "4") {
        var element = <HTMLInputElement>document.getElementById("button4");
        element.removeAttribute("class");
        element.setAttribute("class", "enabled");
        this.button4 = 1;

      }
      if (x[i] == "5") {
        var element = <HTMLInputElement>document.getElementById("button5");
        element.removeAttribute("class");
        element.setAttribute("class", "enabled");
        this.button5 = 1;
      }
      if (x[i] == "6") {
        var element = <HTMLInputElement>document.getElementById("button6");

        element.setAttribute("class", "enabled");
        this.button6 = 1;
      }
      if (x[i] == "7") {
        var element = <HTMLInputElement>document.getElementById("button7");

        element.setAttribute("class", "enabled");
        this.button7 = 1;
      }
      if (x[i] == "8") {
        var element = <HTMLInputElement>document.getElementById("button8");

        element.setAttribute("class", "enabled");
        this.button8 = 1;
      }
      if (x[i] == "9") {
        var element = <HTMLInputElement>document.getElementById("button9");

        element.setAttribute("class", "enabled");
        this.button9 = 1;
      }
      if (x[i] == "10") {
        var element = <HTMLInputElement>document.getElementById("button10");

        element.setAttribute("class", "enabled");
        this.button10 = 1;
      }
      if (x[i] == "11") {
        var element = <HTMLInputElement>document.getElementById("button11");

        element.setAttribute("class", "enabled");
        this.button11 = 1;
      }
      if (x[i] == "12") {
        var element = <HTMLInputElement>document.getElementById("button12");

        element.setAttribute("class", "enabled");
        this.button12 = 1;
      }
      if (x[i] == "13") {
        var element = <HTMLInputElement>document.getElementById("button13");

        element.setAttribute("class", "enabled");
        this.button13 = 1;
      } if (x[i] == "14") {
        var element = <HTMLInputElement>document.getElementById("button14");

        element.setAttribute("class", "enabled");
        this.button14 = 1;
      } if (x[i] == "15") {
        var element = <HTMLInputElement>document.getElementById("button15");

        element.setAttribute("class", "enabled");
        this.button15 = 1;
      }

    }



  }


  f2(i) {
    if (i == "1") {
      var element = <HTMLInputElement>document.getElementById("button1");
      if (this.button1 == 0) {
        this.button1 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button1 = 0;
        element.setAttribute("class", "disabled");
      }


    }


    if (i == "2") {
      var element = <HTMLInputElement>document.getElementById("button2");

      if (this.button2 == 0) {
        this.button2 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button2 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "3") {
      var element = <HTMLInputElement>document.getElementById("button3");
      if (this.button3 == 0) {
        this.button3 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button3 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "4") {
      var element = <HTMLInputElement>document.getElementById("button4");

      if (this.button4 == 0) {
        this.button4 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button4 = 0;
        element.setAttribute("class", "disabled");
      }

    }
    if (i == "5") {
      var element = <HTMLInputElement>document.getElementById("button5");

      if (this.button5 == 0) {
        this.button5 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button5 = 0;
        element.setAttribute("class", "disabled");
      }


    }
    if (i == "6") {
      var element = <HTMLInputElement>document.getElementById("button6");

      if (this.button6 == 0) {
        this.button6 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button6 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "7") {
      var element = <HTMLInputElement>document.getElementById("button7");

      if (this.button7 == 0) {
        this.button7 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button7 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "8") {
      var element = <HTMLInputElement>document.getElementById("button8");

      if (this.button8 == 0) {
        this.button8 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button8 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "9") {
      var element = <HTMLInputElement>document.getElementById("button9");

      if (this.button9 == 0) {
        this.button9 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button9 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "10") {
      var element = <HTMLInputElement>document.getElementById("button10");

      if (this.button10 == 0) {
        this.button10 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button10 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "11") {
      var element = <HTMLInputElement>document.getElementById("button11");

      if (this.button11 == 0) {
        this.button11 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button11 = 0;
        element.setAttribute("class", "disabled");
      }
    }
    if (i == "12") {
      var element = <HTMLInputElement>document.getElementById("button12");

      if (this.button12 == 0) {
        this.button12 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button12 = 0;
        element.setAttribute("class", "disabled");
      }


    }
    if (i == "13") {
      var element = <HTMLInputElement>document.getElementById("button13");

      if (this.button13 == 0) {
        this.button13 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button13 = 0;
        element.setAttribute("class", "disabled");
      }


    }
    if (i == "14") {
      var element = <HTMLInputElement>document.getElementById("button14");

      if (this.button14 == 0) {
        this.button14 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button14 = 0;
        element.setAttribute("class", "disabled");
      }


    }
    if (i == "15") {
      var element = <HTMLInputElement>document.getElementById("button15");

      if (this.button15 == 0) {
        this.button15 = 1;
        element.setAttribute("class", "enabled");
      }
      else {
        this.button15 = 0;
        element.setAttribute("class", "disabled");
      }


    }

  }



  f4() {


    let enabledchapter = "";
    for (let i1 = 1; i1 <= 15; i1++) {


      if (i1 == 1) {

        if (this.button1 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }

      if (i1 == 2) {
        if (this.button2 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }




      if (i1 == 3) {
        if (this.button3 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }
      if (i1 == 4) {
        if (this.button4 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();;
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }


      if (i1 == 5) {
        if (this.button5 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }



      if (i1 == 6) {
        if (this.button6 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }








      if (i1 == 7) {

        if (this.button7 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }

      if (i1 == 8) {
        if (this.button8 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }




      if (i1 == 9) {
        if (this.button9 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }
      if (i1 == 10) {
        if (this.button10 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();;
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }


      if (i1 == 11) {
        if (this.button11 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }



      if (i1 == 12) {
        if (this.button12 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }


      if (i1 == 13) {
        if (this.button13 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }


      if (i1 == 14) {
        if (this.button14 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }


      if (i1 == 15) {
        if (this.button15 == 1) {
          if (enabledchapter == "") {
            enabledchapter = i1.toString();
          }
          else {
            enabledchapter = enabledchapter + "," + i1.toString();
          }
        }
      }

    }

   console.log(enabledchapter);



    var elementtick = <HTMLInputElement>document.getElementById("tick");
    elementtick.setAttribute("style", "display:block");



    $.ajax({
      method: "POST",
      url: "/Home/UpdateContent"
      
    });


    this.f3();



  }

}



